'use client';

import Link from 'next/link';
import { useEffect, useRef } from 'react';

type Props = {
  heading: string;
  body: string;
  linkHref: string;
  linkLabel: string;
};

export function FormSuccessCard({ heading, body, linkHref, linkLabel }: Props) {
  const headingRef = useRef<HTMLHeadingElement | null>(null);

  useEffect(() => {
    headingRef.current?.focus();
  }, []);

  return (
    <div className="bg-[#e6f7f6] border border-[#00A19B]/30 rounded-2xl p-10 text-center">
      <div className="w-16 h-16 bg-[#00A19B] rounded-full flex items-center justify-center mx-auto mb-4">
        <svg
          width="28"
          height="28"
          viewBox="0 0 24 24"
          fill="none"
          stroke="white"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
        >
          <polyline points="20 6 9 17 4 12" />
        </svg>
      </div>
      <h2
        ref={headingRef}
        tabIndex={-1}
        className="text-xl font-bold text-[#373A36] mb-2 focus:outline-none"
      >
        {heading}
      </h2>
      <p className="text-[#6b6e68] mb-6">{body}</p>
      <Link
        href={linkHref}
        className="inline-block text-sm font-semibold text-[#00A19B] hover:underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-[#00A19B] focus-visible:outline-offset-2 rounded"
      >
        {linkLabel}
      </Link>
    </div>
  );
}
